import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import UpdateExternalJobBoardForm from './UpdateExternalJobBoardForm';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';

const UpdateExternalJobBoardModal = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { closeUpdateExternalJobBoardModal } = useBiopharmaGroupActions();

  return (
    <StandardModal
      isOpen={biopharmaGroupState?.updateExternalJobBoardModalIsOpen}
      contentLabel={'Update External Job Board'}
      onRequestClose={() => {
        closeUpdateExternalJobBoardModal();
      }}
    >
      <PageTitle text={'Update External Job Board'} />
      <UpdateExternalJobBoardForm />
    </StandardModal>
  );
};

export default UpdateExternalJobBoardModal;